import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Interfaces
import { CommonTermAndPolicyModel } from '@interfaces/common-page.interface';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private httpClient = inject(HttpClient);

  public getTermsAndCondition(): Observable<CommonTermAndPolicyModel> {
    return this.httpClient.get<CommonTermAndPolicyModel>('/static-pages/terms-and-conditions');
  }

  public getPrivacyPolicy(): Observable<CommonTermAndPolicyModel> {
    return this.httpClient.get<CommonTermAndPolicyModel>('/static-pages/privacy-policy');
  }
}
